module.exports = __webpack_public_path__ + "static/media/our-beyondmeat.2f8732cc.jpg";